/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsDocumentsGeneratedDocumentsInner } from './HchbPatientDetailsDocumentsGeneratedDocumentsInner';
import {
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSON,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSON,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSONTyped,
} from './HchbPatientDetailsDocumentsGeneratedDocumentsInner';
import type { HchbPatientDetailsDocumentsAdditionalDocumentsInner } from './HchbPatientDetailsDocumentsAdditionalDocumentsInner';
import {
    HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSON,
    HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSONTyped,
    HchbPatientDetailsDocumentsAdditionalDocumentsInnerToJSON,
    HchbPatientDetailsDocumentsAdditionalDocumentsInnerToJSONTyped,
} from './HchbPatientDetailsDocumentsAdditionalDocumentsInner';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';

/**
 * 
 * @export
 * @interface HchbPatientDetailsDocuments
 */
export interface HchbPatientDetailsDocuments {
    /**
     * 
     */
    generated_documents?: Array<HchbPatientDetailsDocumentsGeneratedDocumentsInner>;
    /**
     * 
     */
    screener_documents?: Array<Document>;
    /**
     * 
     */
    additional_documents?: Array<HchbPatientDetailsDocumentsAdditionalDocumentsInner>;
}

/**
 * Check if a given object implements the HchbPatientDetailsDocuments interface.
 */
export function instanceOfHchbPatientDetailsDocuments(value: object): value is HchbPatientDetailsDocuments {
    return true;
}

export function HchbPatientDetailsDocumentsFromJSON(json: any): HchbPatientDetailsDocuments {
    return HchbPatientDetailsDocumentsFromJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsDocuments {
    if (json == null) {
        return json;
    }
    return {
        
        'generated_documents': json['generated_documents'] == null ? undefined : ((json['generated_documents'] as Array<any>).map(HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSON)),
        'screener_documents': json['screener_documents'] == null ? undefined : ((json['screener_documents'] as Array<any>).map(DocumentFromJSON)),
        'additional_documents': json['additional_documents'] == null ? undefined : ((json['additional_documents'] as Array<any>).map(HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSON)),
    };
}

export function HchbPatientDetailsDocumentsToJSON(json: any): HchbPatientDetailsDocuments {
    return HchbPatientDetailsDocumentsToJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsToJSONTyped(value?: HchbPatientDetailsDocuments | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generated_documents': value['generated_documents'] == null ? undefined : ((value['generated_documents'] as Array<any>).map(HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSON)),
        'screener_documents': value['screener_documents'] == null ? undefined : ((value['screener_documents'] as Array<any>).map(DocumentToJSON)),
        'additional_documents': value['additional_documents'] == null ? undefined : ((value['additional_documents'] as Array<any>).map(HchbPatientDetailsDocumentsAdditionalDocumentsInnerToJSON)),
    };
}

